<template>
  <b-modal
    id="addressIntervention-error-modal"
    :title="$t('form.incomplete')"
    ok-only
  >
    <div>
      {{this.message}}
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "AddressInterventionErrorModal",

  props: {
    message: String
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/addressIntervention/AddressInterventionErrorModal.vue